<template>
  <v-badge
    bordered
    color="altColor"
    overlap
    :offset-x="large ? 30 : 0"
    :offset-y="large ? 30 : 0"
    :value="user.userType == 'ADMIN'"
  >
    <v-avatar v-if="large" size="150" color="primaryColor">
      <span class="white--text text-h3 text-uppercase"> {{ initials }}</span>
    </v-avatar>
    <v-avatar v-else color="primaryColor">
      <span class="white--text headline text-uppercase"> {{ initials }}</span>
    </v-avatar>
  </v-badge>
</template>

<script>
export default {
  name: "Avatar",
  props: {
    large: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
    initials: {
      type: String,
      required: true,
    },
  },
  data: () => ({}),
};
</script>

<style></style>
